import { render } from "./SubscribeNow.vue?vue&type=template&id=8930a452&ts=true"
import script from "./SubscribeNow.vue?vue&type=script&lang=ts"
export * from "./SubscribeNow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__